import React, { useCallback, useState, useRef } from 'react';
import cn from 'classnames';
import PT from 'prop-types';

import Icon from '../Icon';

const Checkbox = ({
  checked,
  name,
  value,
  onChange,
  disabled,
  className,
  label,
  ...restProps
}) => {
  const inputRef = useRef(null);

  const [checkedState, setCheckedState] = useState(Boolean(checked));

  const handleLabelClick = useCallback(() => {
    inputRef.current && inputRef.current.click();
  }, []);

  const handleChange = useCallback(e => {
    if (typeof checked === 'undefined') {
      const {
        target: {
          checked
        }
      } = e;

      setCheckedState(checked);
    }

    onChange && onChange(e);
  }, [checked, onChange]);

  return (
    <div
      className={cn(
        'checkbox',
        className
      )}
    >
      <div
        className="checkbox__input-container"
      >
        <input
          className="checkbox__input"
          type="checkbox"
          name={name}
          value={value}
          onChange={handleChange}
          checked={checked}
          disabled={disabled}
          ref={inputRef}
          {...restProps}
        />
        {(checked || checkedState) && (
          <div
            className="checkbox__mark"
          >
            <Icon
              name="icon-done"
            />
          </div>
        )}
      </div>
      {label && (
        <p
          className="checkbox__label"
          onClick={handleLabelClick}
        >{label}</p>
      )}
    </div>
  )
};

Checkbox.propTypes = {
  checked: PT.bool,
  name: PT.string,
  value: PT.string,
  onChange: PT.func,
  disabled: PT.bool,
  className: PT.string
};

export default Checkbox;
